import type { FC } from "react";

import { IconBarchart } from "../icons/icon-barchart";
import { IconChartUp } from "../icons/icon-chart-up";
import { IconCheckmark } from "../icons/icon-checkmark";
import { IconHeart } from "../icons/icon-heart";
import { IconRepeat } from "../icons/icon-repeat";
import { IconStars } from "../icons/icon-stars";
import { PayPlan } from "../payment-plan";

const title: Record<number, string> = {
  30: "1 місяць",
  90: "3 місяці",
  360: "12 місяців",
};

const description: Record<number, string> = {
  30: "Зрозумійте свій стан тут і зараз",
  90: "Відстежуйте зміни та поверніть контроль",
  360: "Системна підтримка і глибока трансформація",
};

const repeat: Record<number, string> = {
  30: "Повторний чекап",
  90: "До 6 чекапів у межах доступу",
  360: "До 24 чекапів у межах доступу",
};

export const VariantFozzy: FC<{ plan: PayPlan }> = ({ plan }) => {
  return (
    <PayPlan.Card>
      <PayPlan.Title>{title[plan.duration]}</PayPlan.Title>
      <PayPlan.Description minHeight={56}>
        {description[plan.duration]}
      </PayPlan.Description>
      <PayPlan.Price plan={plan} />
      <PayPlan.Benefits>
        <PayPlan.BenefitsItem Icon={IconChartUp}>
          Оцінку вашого стану (до 55+ показників)
        </PayPlan.BenefitsItem>
        <PayPlan.BenefitsItem Icon={IconCheckmark}>
          Зрозумілі пояснення показників
        </PayPlan.BenefitsItem>
        <PayPlan.BenefitsItem Icon={IconStars}>
          Персоналізовані рекомендації
        </PayPlan.BenefitsItem>
        <PayPlan.BenefitsItem Icon={IconHeart}>
          Завантаження результатів
        </PayPlan.BenefitsItem>
        <PayPlan.BenefitsItem Icon={IconRepeat}>
          {repeat[plan.duration] ?? repeat[30]}
        </PayPlan.BenefitsItem>
        <PayPlan.BenefitsItem Icon={IconBarchart}>
          Динаміка змін показників
        </PayPlan.BenefitsItem>
      </PayPlan.Benefits>
      <PayPlan.Action plan={plan}>Отримати доступ</PayPlan.Action>
    </PayPlan.Card>
  );
};
